import { MainWrapper } from "./MainWrapper";
import style from "../../assets/scss/sub/downloadTest.module.scss";
import downloadIcon from "../../assets/images/header/download_icon.svg";
import appGuide1 from "../../assets/images/sub/download_test_guide/app_guide_1.png";
import appGuide2 from "../../assets/images/sub/download_test_guide/app_guide_2.png";
import appGuide3 from "../../assets/images/sub/download_test_guide/app_guide_3.png";
import appGuide4 from "../../assets/images/sub/download_test_guide/app_guide_4.png";
import windowGuide1 from "../../assets/images/sub/download_test_guide/window_guide_1.png";
import windowGuide2 from "../../assets/images/sub/download_test_guide/window_guide_2.png";
import windowGuide3 from "../../assets/images/sub/download_test_guide/window_guide_3.png";
import windowGuide4 from "../../assets/images/sub/download_test_guide/window_guide_4.png";
import windowGuide5 from "../../assets/images/sub/download_test_guide/window_guide_5.png";
import appStoreBadge from "../../assets/images/sub/download_test_guide/app_store_badge.png";
import appStoreBadgeMobile from "../../assets/images/sub/download_test_guide/app_store_badge_mobile.png";
import googlePlayBadge from "../../assets/images/sub/download_test_guide/google_play_badge.png";
import googlePlayBadgeMobile from "../../assets/images/sub/download_test_guide/google_play_badge_mobile.png";
import { ArticleTitle } from "./ArticleTitle";
import { useCallback, useEffect, useState } from "react";
import { GuideListItem } from "./download/GuideListItem";
import { useUserAgent } from "../../hooks/hooks";

enum OSType {
  WINDOW = "window",
  APP = "app",
}

export function DownloadTest() {
  const [osType, setOsType] = useState<OSType>(OSType.WINDOW);
  const { isDesktop } = useUserAgent();
  const onClickTabMenu = useCallback((type: OSType) => setOsType(type), []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `검사 다운로드 | ${process.env.REACT_APP_TITLE}`;
  }, []);

  const GuideNode = useCallback(() => {
    switch (osType) {
      case OSType.WINDOW:
        return (
          <div className={style.guideContent}>
            <a className={style.downloadBtn} href={"https://images.feel-good.io/setup/K-PASS.exe"}>
              Windows 용 다운로드
              <img className={style.icon} src={downloadIcon} alt={"Window Download Link"} />
            </a>
            <ol className={style.orderedListGuide}>
              <GuideListItem
                number={1}
                normalText={`[ Windows 용 다운로드 ] 버튼을 클릭하시면 프로그램 파일이 다운로드 됩니다.\n다운로드 후 하단의 다운된 [ K-PASS ] 프로그램을 클릭해 주세요.`}
                accentText={
                  "*K-PASS 구동 가능한 PC 최소 사양을 확인하신 후 설치해 주세요.\n" +
                  "*PC 사양 문제로 검사 진행 불가능 시 환불 처리가 어렵습니다.\n" +
                  "[CPU: 인텔 8세대 (8000 시리즈) 이상]\n" +
                  "[AMD: 라이젠 3세대 (3000 시리즈) 이상]\n" +
                  "[메모리: 8GB 이상]\n" +
                  "[OS: 윈도우10 이상]"
                }
                imageUrl={windowGuide1}
              />
              <GuideListItem
                number={2}
                normalText={"[ K-PASS ] 설치를 진행합니다."}
                accentText={
                  "*태블릿 또는 PC에서 진행 가능합니다. 모바일에서는 불가능합니다.\n" +
                  "*태블릿에서 진행할 경우 스토어에서 '케이패스‘ 또는 ’K-PASS'를 다운로드해주세요."
                }
                imageUrl={windowGuide2}
              />
              <GuideListItem
                number={3}
                normalText={
                  "[K-PASS] 실행 후 [ K-PASS with 앱 ] 에서 가입한 계정으로 로그인해 주세요.\n" +
                  "(소속 이용권으로 진행 시 [ 소속코드 로그인 ] 으로 로그인해 주세요.)"
                }
                accentText={""}
                imageUrl={windowGuide3}
              />
              <GuideListItem
                number={4}
                normalText={"자녀의 프로필을 확인·선택합니다."}
                accentText={"* [ K-PASS with 앱 ] - [ 자녀관리 ] 메뉴에서 자녀 등록 및 수정이 가능합니다."}
                imageUrl={windowGuide4}
              />
              <GuideListItem
                number={5}
                normalText={"보유한 검사 이용권 수량을 확인 후 검사를 진행합니다."}
                accentText={
                  "*검사준비 안내사항을 꼭! 확인하신 후 진행해 주세요.\n" +
                  "*검사 이용권은 [ K-PASS 홈페이지 ] 에서 구매하실 수 있습니다."
                }
                imageUrl={windowGuide5}
              />
            </ol>
          </div>
        );
      case OSType.APP:
        return (
          <div className={style.guideContent}>
            <div className={style.googlePlayGuide}>
              <span className={style.text}>
                지금 스토어 에서
                {isDesktop ? <> </> : <br />}
                <span className={style.accent}>
                  &nbsp;&nbsp;‘케이패스’&nbsp;&nbsp;or&nbsp;’K-PASS’&nbsp;&nbsp;검색!
                </span>
              </span>
              <div className={style.badges}>
                <a
                  href={"https://play.google.com/store/apps/details?id=com.feelgood.kpass&hl=ko"}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <img
                    className={style.badgeImage}
                    src={isDesktop ? googlePlayBadge : googlePlayBadgeMobile}
                    alt={"구글 플레이스토어 뱃지"}
                  />
                </a>
                <a
                  href={"https://apps.apple.com/kr/app/k-pass-%EC%BC%80%EC%9D%B4%ED%8C%A8%EC%8A%A4/id6448768648"}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <img
                    className={style.badgeImage}
                    src={isDesktop ? appStoreBadge : appStoreBadgeMobile}
                    alt={"앱 스토어 뱃지"}
                  />
                </a>
              </div>
            </div>
            <ol className={style.orderedListGuide}>
              <GuideListItem
                number={1}
                normalText={"태블릿으로 스토어에 접속하여 [ K-PASS ] 를 다운로드해 주세요."}
                accentText={
                  "*태블릿 또는 PC에서 진행 가능합니다. 모바일에서는 불가능합니다.\n" +
                  "*PC에서 진행할 경우 [ K-PASS 홈페이지 ] 에서 Windows 용을 다운로드해 주세요."
                }
                imageUrl={appGuide1}
              />
              <GuideListItem
                number={2}
                normalText={
                  "[K-PASS] 실행 후 [ K-PASS with 앱 ] 에서 가입한 계정으로 로그인해 주세요.\n" +
                  "(소속 이용권으로 진행 시 [ 소속코드 로그인 ] 으로 로그인해 주세요.)"
                }
                accentText={""}
                imageUrl={appGuide2}
              />
              <GuideListItem
                number={3}
                normalText={"자녀의 프로필을 확인·선택합니다."}
                accentText={"* [ K-PASS with 앱 ] - [ 자녀관리 ] 메뉴에서 자녀 등록 및 수정이 가능합니다."}
                imageUrl={appGuide3}
              />
              <GuideListItem
                number={4}
                normalText={"보유한 검사 이용권 수량을 확인 후 검사를 진행합니다."}
                accentText={
                  "*검사준비 안내사항을 꼭! 확인하신 후 진행해 주세요.\n" +
                  "*검사 이용권은 [ K-PASS 홈페이지 ] 에서 구매하실 수 있습니다."
                }
                imageUrl={appGuide4}
              />
            </ol>
          </div>
        );
    }
  }, [osType, isDesktop]);

  return (
    <>
      <MainWrapper showFooter={true} mainClassName={style.downloadTest}>
        <>
          <div className={style.bgItem1}></div>
          <div className={style.bgItem2}></div>
          <div className={style.title}>
            <ArticleTitle title="검사 다운로드" className={""} />
          </div>
          <div className={style.tabMenu}>
            <button
              className={`${style.tab} ${osType === OSType.WINDOW ? style.active : ""}`}
              onClick={() => onClickTabMenu(OSType.WINDOW)}
            >
              Windows 용
            </button>
            <button
              className={`${style.tab} ${osType === OSType.APP ? style.active : ""}`}
              onClick={() => onClickTabMenu(OSType.APP)}
            >
              Android / iOS 용
            </button>
          </div>
          <GuideNode />
        </>
      </MainWrapper>
    </>
  );
}
